// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__qZv+U","spin":"loader_spin__CVjh5"};